// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"95":"aa758fe7","168":"4227514c","289":"5d00c9ff","461":"52d99d8f","501":"2d567e20","613":"b6753e36","696":"948f52bd","728":"c2beef9f","911":"8843aa0a","936":"320e61b0"}[chunkId] + ".js";
};